import { useMemo } from 'react';

import { Order, TYPES_CVE_LIST_PAGE_SIZE } from '../constants';

interface State {
    type: string;
    order: Order;
    page: number;
}

export function useTypesCveCatalogPayload(state: State) {
    return useMemo(() => {
        const { type, order, page } = state;
        return {
            query: [
                `type:${type}`,
                order === Order.MOST_VIEWED ? `order:viewCount` : order === Order.DATE ? 'order:published' : ''
            ]
                .filter(Boolean)
                .join(' '),
            size: TYPES_CVE_LIST_PAGE_SIZE,
            skip: Math.max(page - 1, 0) * TYPES_CVE_LIST_PAGE_SIZE,
            fields: [
                'bounty',
                'bulletinFamily',
                'cvss',
                'cvss2',
                'cvss3',
                'description',
                'enchantments',
                'epss',
                'href',
                'id',
                'lastseen',
                'modified',
                'published',
                'sourceData',
                'title',
                'type',
                'vhref',
                'viewCount'
            ]
        };
    }, [state]);
}
